import { transformShippingPointDto } from './shipping-point';
export const transformPickupPointDto = _ref => {
  let {
    distance,
    preferred,
    point,
    distance_unit,
    distance_label,
    package_type_id
  } = _ref;
  return {
    distance,
    preferred,
    distanceUnit: distance_unit,
    distanceLabel: distance_label,
    packageTypeId: package_type_id,
    point: transformShippingPointDto(point)
  };
};
export const transformPickupPointsDto = pickupPointDto => pickupPointDto.map(transformPickupPointDto);